<template>
  <span class="fontawesome-icon">
    <!-- Type: 'layers' -->
    <font-awesome-layers v-if="type === 'layers'" full-width>
      <font-awesome-icon
        :icon="icon"
        :mask="iconMask"
        :style="{ color: getColor(color) }"
        :transform="transform"
      />

      <!-- loop through children -->
      <template v-for="child in iconChildren">
        <font-awesome-layers-text
          v-if="child.type === 'text'"
          :key="child.icon"
          :value="child.text"
          :style="{ color: getColor(child.color) }"
          :transform="child.transform"
        />
        <font-awesome-icon
          v-else
          :key="child.icon"
          :icon="child.icon"
          :style="{ color: getColor(child.color) }"
          :transform="child.transform"
        />
      </template>
    </font-awesome-layers>

    <!-- Type: 'icon' -->
    <font-awesome-icon
      v-else
      :icon="icon"
      :mask="iconMask"
      :style="{ color: getColor(color) }"
      :transform="transform"
      class="fa-fw"
    />
  </span>
</template>

<script>
export default {
  name: 'IconFontawesome',

  props: {
    /**
     * 'icon' | 'layers'
     */
    type: {
      type: String,
      default: 'icon'
    },
    icon: {
      type: [String, Array],
      required: true
    },
    iconMask: {
      type: [String, Array],
      required: false,
      default: null
    },
    color: {
      type: String,
      required: false,
      default: null
    },
    transform: {
      type: String,
      required: false,
      default: null
    },
    iconChildren: {
      type: Array,
      required: false,
      default: null
    }
  },

  computed: {
    theme() {
      return this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark
        : this.$vuetify.theme.themes.light
    }
  },

  methods: {
    getColor(color) {
      // If it is a color from the theme, than return it. Otherwise return the color.
      return this.theme[color] ? this.theme[color] : color
    }
  }
}
</script>

<style lang="scss" scoped>
.fontawesome-icon::v-deep {
  svg {
    fill: currentColor;
  }
}
</style>
